module.exports = __webpack_public_path__ + "img/tab-3.47191f2f.svg";